export const Language = {
  UA: 'UA',
  EN: 'EN',
}

export const InvoiceStatus = {
  DRAFT: 'draft',
  ACTIVATED: 'active',
  PARTIALLY_PAID: 'partially_paid',
  FULLY_PAID: 'fully_paid',
  OVERPAYMENT: 'overpayment',
  IN_PAYMENT_PROCESS: 'in_payment_process',
  IN_PAYMENT: 'in_payment',
  PARTIAL_REFUND: 'partial_refund',
  FULL_REFUND: 'full_refund',
  CANCELED: 'canceled',
  OVERDUE: 'overdue',
}

export const InvoiceType = {
  STANDARD: 'standard',
  PROFORMA: 'proforma',
  CREDIT_NOTE: 'credit_note',
  RECURRING: 'recurring',
  DEBIT_NOTE: 'debit_note',
}

export const RecipientType = {
  INDIVIDUAL: 'individual',
  ENTITY: 'entity',
  ON_PAYMENT: 'on_payment',
}

export const DiscountType = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed',
}

export const TransactionType = {
  PAYMENT: 'payment',
  REFUND: 'refund',
}
